import { GameState } from './GameState';
import { EventBus } from './EventBus';

const DECAY_PER_HOUR = 8; // 게이지/시간
const FEED_AMOUNT = 30;
const PLAY_HAPPINESS = 20;
const PLAY_EXP = 10;
const BATH_AMOUNT = 40;
const EXP_PER_LEVEL = 100;

function clamp(v: number, lo = 0, hi = 100): number { return Math.max(lo, Math.min(hi, v)); }

export const PetCareEngine = {
  feed(petId: string): void {
    const pet = GameState.data.ownedPets.find(p => p.petId === petId);
    if (!pet) return;
    pet.hunger = clamp(pet.hunger + FEED_AMOUNT);
    pet.happiness = clamp(pet.happiness + 5);
    pet.lastCaredAt = Date.now();
    GameState.persist();
    EventBus.emit('toast', { message: '🍖 냠냠!', kind: 'gold' });
  },

  play(petId: string): void {
    const pet = GameState.data.ownedPets.find(p => p.petId === petId);
    if (!pet) return;
    pet.happiness = clamp(pet.happiness + PLAY_HAPPINESS);
    pet.exp += PLAY_EXP;
    let leveled = false;
    while (pet.exp >= EXP_PER_LEVEL) {
      pet.exp -= EXP_PER_LEVEL;
      pet.level++;
      leveled = true;
    }
    pet.lastCaredAt = Date.now();
    GameState.persist();
    if (leveled) {
      EventBus.emit('toast', { message: `🌟 레벨 업! Lv.${pet.level} 달성!`, kind: 'gold' });
    } else {
      EventBus.emit('toast', { message: '🎾 신난다!', kind: 'gold' });
    }
  },

  bath(petId: string): void {
    const pet = GameState.data.ownedPets.find(p => p.petId === petId);
    if (!pet) return;
    pet.cleanliness = clamp(pet.cleanliness + BATH_AMOUNT);
    pet.happiness = clamp(pet.happiness + 5);
    pet.lastCaredAt = Date.now();
    GameState.persist();
    EventBus.emit('toast', { message: '🛁 깨끗해!', kind: 'gold' });
  },

  applyTimeDecay(): void {
    const now = Date.now();
    let changed = false;
    for (const pet of GameState.data.ownedPets) {
      const elapsedHours = (now - pet.lastCaredAt) / (60 * 60 * 1000);
      if (elapsedHours <= 0) continue;
      const decay = elapsedHours * DECAY_PER_HOUR;
      pet.happiness = clamp(pet.happiness - decay);
      pet.hunger = clamp(pet.hunger - decay);
      pet.cleanliness = clamp(pet.cleanliness - decay * 0.7);
      pet.lastCaredAt = now;
      changed = true;
    }
    if (changed) GameState.persist();
  },

  setActive(petId: string): void {
    const pet = GameState.data.ownedPets.find(p => p.petId === petId);
    if (!pet) return;
    GameState.data.activePetId = petId;
    GameState.persist();
    EventBus.emit('toast', { message: `${pet.nickname}와 함께!` });
  },

  addPet(petId: string, nickname?: string): void {
    if (GameState.data.ownedPets.some(p => p.petId === petId)) return;
    const now = Date.now();
    GameState.data.ownedPets.push({
      petId, nickname: nickname ?? petId,
      level: 1, exp: 0,
      happiness: 80, hunger: 70, cleanliness: 90,
      lastCaredAt: now, acquiredAt: now,
    });
    if (!GameState.data.activePetId) GameState.data.activePetId = petId;
    GameState.persist();
  },
};
